import './Tree.less';
import React from 'react';
import {ReactSortable} from "react-sortablejs";
import __ from "../../../i18n";
import Icon from "../../../../bootstrap/components/icon/Icon";
import Button from "../../../../bootstrap/components/button/Button";
import createEmptySection from "../utils/createEmptySection";
import createEmptyQuestion from "../utils/createEmptyQuestion";
import createEmptyPiece from "../utils/createEmptyPiece";


export default function Tree({selectedNodeHash, setSelectedNodeHash, setQuestions, setSections, setPieces, questions, sections, pieces, questionErrors, sectionErrors, pieceErrors}) {

    const nodes = [
        ...sections,
        ...questions.filter(q => q.group_id === null),
    ];

    {
        const comparator = (a, b) => a.sort_order - b.sort_order;
        nodes.sort(comparator);
        questions.sort(comparator);
    }

    return <div className="tree">
        <ReactSortable
            className="nodes"
            list={[1].concat(nodes)}
            setList={(list) => {
                requestAnimationFrame(() => {
                    list.slice(1).forEach((node, index) => {
                        if (node.hasOwnProperty('group_id')) {
                            setQuestions(questions => {
                                return questions.map(question => {
                                    if (question.id === node.id) {
                                        question.group_id = null;
                                        question.sort_order = index + 1;
                                    }
                                    return question;
                                });
                            });
                        }
                        setSections(sections => {
                            return sections.map(section => {
                                if (section.id === node.id) {
                                    section.sort_order = index + 1;
                                }
                                return section;
                            });
                        });
                    });
                });
            }}
            group="nodes"
            handle=".node"
            animation={150}
            fallbackOnBody={true}
        >
            <div key="quiz" className="branch root-branch">
                <div
                    className={'node quiz-node ' + (selectedNodeHash === 'quiz' ? 'selected' : '')}
                    onMouseDown={() => {
                        setSelectedNodeHash('quiz');
                    }}
                >
                    {__('Basic information')}
                </div>
            </div>
            {
                nodes.map(node => {
                    if (node.hasOwnProperty('group_id')) {
                        const question = node;
                        const questionHash = `question:${question.id}`;
                        return <div
                            key={questionHash}
                            className="branch"
                        >
                            <div
                                onMouseDown={() => {
                                    setSelectedNodeHash(questionHash);
                                }}
                                className={'node question-node ' + (questionHash === selectedNodeHash ? 'selected' : '')}
                            >
                                <div>{__('Question: ::id', {id: question.id})}</div>
                                {
                                    (
                                        questionErrors.hasOwnProperty(question.id)
                                        || pieces.filter(p => p.question_id === question.id)
                                            .some(p => pieceErrors.hasOwnProperty(p.id))
                                    ) &&
                                    <div>
                                        <Icon name="caution-circle"/>
                                    </div>
                                }
                            </div>
                        </div>;
                    }

                    {
                        const section = node;
                        const sectionHash = `section:${section.id}`;
                        const sectionQuestions = questions.filter(question => question.group_id === section.id);
                        return <div
                            key={sectionHash}
                            className="branch"
                        >
                            <div
                                onMouseDown={() => {
                                    setSelectedNodeHash(sectionHash);
                                }}
                                className={'node section-node ' + (sectionHash === selectedNodeHash ? 'selected' : '')}
                            >
                                <div>{__('Section: ::id', {id: section.id})}</div>
                                {
                                    sectionErrors.hasOwnProperty(section.id) &&
                                    <div>
                                        <Icon name="caution-circle"/>
                                    </div>
                                }
                            </div>
                            <ReactSortable
                                className="nodes section-nodes"
                                list={sectionQuestions}
                                setList={(list) => {
                                    requestAnimationFrame(() => {
                                        list.forEach((q, index) => {
                                            if (!q.hasOwnProperty('group_id')) {
                                                return;
                                            }
                                            setQuestions(questions => {
                                                return questions.map(question => {
                                                    if (question.id === q.id) {
                                                        question.group_id = section.id;
                                                        question.sort_order = index + 1;
                                                    }
                                                    return question;
                                                });
                                            });
                                        });
                                    });
                                }}
                                group="nodes"
                                handle=".node"
                                animation={150}
                                fallbackOnBody={true}
                            >
                                {
                                    sectionQuestions.map(question => {
                                        const hash = `question:${question.id}`;
                                        return <div
                                            key={hash}
                                            onMouseDown={() => {
                                                setSelectedNodeHash(hash);
                                            }}
                                            className={'node question-node section-question-node ' + (hash === selectedNodeHash ? 'selected' : '')}
                                        >
                                            <div>{__('Question: ::id', {id: question.id})}</div>
                                            {
                                                (
                                                    questionErrors.hasOwnProperty(question.id)
                                                    || pieces.filter(p => p.question_id === question.id)
                                                        .some(p => pieceErrors.hasOwnProperty(p.id))
                                                ) &&
                                                <div>
                                                    <Icon name="caution-circle"/>
                                                </div>
                                            }
                                        </div>;
                                    })
                                }
                            </ReactSortable>
                            <div className="buttons section-buttons">
                                <Button
                                    title={__('Add question')}
                                    appearance="text-primary"
                                    onClick={() => {
                                        const newQuestion = createEmptyQuestion(section.id, sectionQuestions.length + 1);
                                        setQuestions(questions => questions.concat([newQuestion]));
                                        setSelectedNodeHash(`question:${newQuestion.id}`);

                                        setPieces(pieces => pieces.concat([
                                            createEmptyPiece(newQuestion.id, 1),
                                            createEmptyPiece(newQuestion.id, 2),
                                        ]));
                                    }}
                                />
                            </div>
                        </div>;
                    }
                })
            }
        </ReactSortable>
        <div className="buttons">
            <Button
                title={__('Add question')}
                appearance="outline-primary"
                onClick={() => {
                    const newQuestion = createEmptyQuestion(null, nodes.length + 1);
                    setQuestions(questions => questions.concat([newQuestion]));
                    setSelectedNodeHash(`question:${newQuestion.id}`);

                    setPieces(pieces => pieces.concat([
                        createEmptyPiece(newQuestion.id, 1),
                        createEmptyPiece(newQuestion.id, 2),
                    ]));
                }}
            />
            <Button
                title={__('Add section')}
                appearance="outline-accent"
                onClick={() => {
                    const newSection = createEmptySection(nodes.length + 1);
                    setSections(sections => sections.concat([newSection]));
                    setSelectedNodeHash(`section:${newSection.id}`);
                }}
            />
        </div>
    </div>;
}
